// Components rendered in the initial page retain their normal module tags.
// This also covers components inserted later by search, quick add or sections.
let tlPendingComponents = [
  { selector: 'deferred-media, product-model', load: () => import('@theme/media') },
  { selector: 'product-sku-component', load: () => import('@theme/product-sku') },
  { selector: 'product-inventory', load: () => import('@theme/product-inventory') },
  { selector: 'show-more-component', load: () => import('@theme/show-more') },
  { selector: 'volume-pricing', load: () => import('@theme/volume-pricing') },
  { selector: 'price-per-item', load: () => import('@theme/price-per-item') },
];

const tlComponentObserver = new MutationObserver((records) => {
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (node instanceof Element) tlLoadComponents(node);
    }
  }
});

/** @param {Document | Element} root */
function tlLoadComponents(root) {
  tlPendingComponents = tlPendingComponents.filter(({ selector, load }) => {
    if (!(root instanceof Element && root.matches(selector)) && !root.querySelector(selector)) return true;
    load().catch((error) => console.error('[tl-optional-components] Module failed to load:', error));
    return false;
  });
  if (tlPendingComponents.length === 0) tlComponentObserver.disconnect();
}

tlComponentObserver.observe(document.documentElement, { childList: true, subtree: true });
tlLoadComponents(document);
